export const DueSoon = () => (
	<span className='text-warning'><b>due soon</b></span>
)